<template>
    <div
        id="info"
        class="bg-light"
    >
        <div class="body-wrapper">
            <gallery-header />

            <main>
                <div class="container-fluid mt-5">
                    <div class="row">
                        <div class="col-md-3 offset-md-1 col-lg-3 offset-lg-2">
                            <ul
                                class="categorie-listino nav nav-tabs d-flex flex-row flex-md-column justify-content-center"
                                role="tablist"
                                aria-orientation="vertical"
                            >
                                <li
                                    class="nav-item"
                                    v-for="category in categories"
                                    :key="category"
                                >
                                    <a
                                        class="nav-link text-uppercase font-weight-bold"
                                        href="javascript:void(0)"
                                        :class="{'active': category === selectedCategory}"
                                        @click="selectCategory(category)"
                                    >
                                        {{ category }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-7 col-lg-5 mt-3 mt-md-0">
                            <div class="tab-content fade show">
                                <div
                                    class="tab-pane active"
                                    v-show="selectedCategory.length > 0"
                                >
                                    <h2 class="mb-0">{{ selectedCategory }}</h2>
                                    <ul class="elementi-categoria-listino mb-0 mt-3">
                                        <li
                                            class="elemento d-flex justify-content-between align-items-center py-1"
                                            :class="{'border-top': index > 0}"
                                            v-for="(article, index) in pricelist[selectedCategory]"
                                            :key="article.code"
                                        >
                                            <div class="nome flex-grow-1 px-1">
                                                {{article.name}}
                                            </div>
                                            <div class="prezzo text-right px-1 font-weight-bold">
                                                {{article.price | toCurrency}}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";

export default {
    name: "EventInfo",

    components: { GalleryHeader, GalleryFooter },

    data() {
        return {
            pricelist: {},
            categories: [],
            selectedCategory: ""
        };
    },

    mounted() {
        this.$api.getEventDataInfo().then((response) => {
            console.debug("EVENT_DATA_INFO", response);
            if (response.pricelist) {
                this.pricelist = response.pricelist;
                if (this.pricelist) {
                    this.categories = Object.keys(this.pricelist);
                    if (this.categories.length > 0) {
                        this.selectedCategory = this.categories[0];
                    }
                }
            }
        });
    },

    methods: {
        selectCategory(category) {
            this.selectedCategory = category;
        }
    }
};
</script>

<style></style>
